import { useMutation } from "@tanstack/react-query";
import api, { type ApiError } from "../api/http";
import type { AcceptInviteRequest, AcceptInviteResponse } from "../api/types";

export function useAcceptInvite() {
  return useMutation<AcceptInviteResponse, ApiError, AcceptInviteRequest>({
    mutationFn: (data) =>
      api.post<AcceptInviteResponse>(
        "/api/v1/employees/accept-invite/",
        data,
      ),
  });
}
